import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CheckCircle } from "lucide-react";
import PaymentLayout from "../layouts/PaymentLinkLayouts";
import formatCurrency from "../../utils/numberFormatter";
import { formatDateTime } from "../../utils/dateFormatter";
import RedirectCountdown from "../components/RedirectCountdown";

export default function PaymentSuccess() {
  const location = useLocation();
  const paymentData = location.state || {};
  const [amount] = formatCurrency(paymentData.amount).split(',');
  const date = formatDateTime(paymentData.paymentDate);
  const { card_title } = useSelector((state) => state.style);

  return (
    <PaymentLayout title={card_title || "Payment Successful"}>
      <div>
        <h2 className="text-4xl font-bold">{amount}</h2>
        <p className="text-gray-600 mt-2">Reff No. {paymentData.reffNo}</p>
        <div className=" text-gray-600">Method: {paymentData.paymentMethod}</div>
      </div>

      <div className="text-center ">
        <CheckCircle size={64} className="text-green-500 mx-auto" />
        <h2 className="text-2xl font-bold mt-4">Pembayaran Berhasil</h2>
        <p className="text-gray-600 mt-2">Terima kasih, pembayaran Anda telah berhasil diproses.</p>
      </div>

      <div className="mt-6 text-left space-y-2 border-t pt-4">
        <p><strong>Reff No:</strong> {paymentData.reffNo || "-"}</p>
        {paymentData.customerName && <p><strong>Nama Pelanggan:</strong> {paymentData.customerName}</p>}
        {paymentData.email && <p><strong>Email:</strong> {paymentData.email}</p>}
        {paymentData.phone && <p><strong>No. HP:</strong> {paymentData.phone}</p>}
        <p><strong>Metode Pembayaran:</strong> {paymentData.paymentMethod || "-"}</p>
        <p><strong>Total Pembayaran:</strong> {amount}</p>
        <p><strong>Tanggal Pembayaran:</strong> {date || "-"}</p>
      </div>

      <RedirectCountdown redirectUrl={paymentData.redirectUrl} />
    </PaymentLayout>
  );
}